import axios from "axios";
import React, { useEffect, useState } from "react";
import AboutCard from "../../components/Common/AboutCard";
import NodataAvailable from "../../components/Common/NodataAvailable";
import ContentLoader from "../ContentLoader";
import i18n from "i18next";
const Refund = () => {
  const [title, setTitle] = useState("");
  const [details, setDetails] = useState("");
  const currentLang = i18n.language;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`api/refund`).then((res) => {
      setLoading(false);
      if (res.data.status === 200) {
        setTitle(currentLang === 'en' ? res.data?.data.title : res.data?.data.title_bn);
        setDetails(currentLang === 'en' ? res.data?.data.details : res.data?.data.details_bn);
      }
    });
  }, [currentLang]);

  return (
    <>
      {loading ? (
        <ContentLoader />
      ) : (
        <>
          {details.length === 0 ? (
            <NodataAvailable />
          ) : (
            <AboutCard title={title} description={details} />
          )}
        </>
      )}
    </>
  );
};

export default Refund;
